import Vue from 'vue';
// eslint-disable-next-line
import { SearchTasks, getUsers, getUsersCustomer } from '@/api/index';
import store from '@/store';
import { Consts } from 'gw-js-lib';

export default {
  namespaced: true,
  state: { /* = data */
    tasks: {
      PENDING: [],
      IN_PROGRESS: [],
      COMPLETED: [],
    },
    users: [],
    loading: {
      PENDING: false,
      IN_PROGRESS: false,
      COMPLETED: false,
    },
  },

  getters: { /* = Computed properties, perfects to filter data an execute some calculation */
  },


  actions: { /* = Methods */

    loadAllTasks({ dispatch }, {userId, showLoading}) {
      let payloadPending = {
        page: 1,
        rows: 100,
        order_by: "orden asc, time_updated desc",
        filters: {
            course_id: store.state.course.course_id,
            status: Consts.TaskStatus.PENDING,
            assigned_to: userId,
        }
      };

      if (payloadPending.filters.assigned_to == null) {
        //Staff users can only see his tasks
        delete payloadPending.filters.assigned_to;
      }

      dispatch('loadTasks', {payload: payloadPending, showLoading: showLoading} );

      let payloadInProgress = JSON.parse(JSON.stringify(payloadPending));
      payloadInProgress.filters.status = Consts.TaskStatus.IN_PROGRESS;
      dispatch('loadTasks', {payload: payloadInProgress, showLoading: showLoading});

      let payloadCompleted = JSON.parse(JSON.stringify(payloadInProgress));
      payloadCompleted.filters.status = Consts.TaskStatus.COMPLETED;
      dispatch('loadTasks', {payload: payloadCompleted, showLoading: showLoading});
    },

    loadTasks({ commit }, {payload, showLoading}) {
      if (showLoading) {
        commit('setLoading', {status: payload.filters.status, loading: true});
      }
      SearchTasks(payload).then((res) => {
        commit('setTasks', {tasks: res.rows, status: payload.filters.status});
        commit('setLoading', {status: payload.filters.status, loading: false});
      });
    },

    loadUsers({ commit }) {
      getUsers(null).then((response) => {
        commit('setUsers', response.users);
      });
    },

    loadUsersCustomer({ commit }) {
      getUsersCustomer(null).then((response) => {
        commit('setUsers', response.users);
      });
    },

    pushTask({ commit, state, rootState }, task) {
      
      if (rootState.Dashboard.tasks) {
        const indexDashboardTask = rootState.Dashboard.tasks.findIndex((t) => t.task_id === task.task_id);
        if (indexDashboardTask > -1) {
          Vue.set(rootState.Dashboard.tasks, indexDashboardTask, task);
        } else {
          rootState.Dashboard.tasks.push(task);
        }
      }

      const currentIndex = state.tasks[task.status].findIndex((t) => t.task_id === task.task_id);
      commit('pushTask', {task: task, currentIndex: currentIndex});
    },

    deleteTask({ commit, state, rootState }, task) {
      const currentIndex = state.tasks[task.status].findIndex((t) => t.task_id === task.task_id);
      commit('deleteTask', {task: task, currentIndex: currentIndex});
    },

  },

  mutations: { /* Mutations are responsible to change the state */
    setTasks(state, {tasks, status}) {
      state.tasks[status] = tasks;
    },

    pushTask(state, {task, currentIndex}) {
      if (currentIndex > -1) {
        Vue.set(state.tasks[task.status], currentIndex, task);
      } else {
        state.tasks[task.status].push(task);
      }
    },

    moveTask(state, task, root) {
      const currentIndex = state.tasks[task.status].findIndex((t) => t.task_id === task.task_id);
      if (currentIndex > -1) {
        Vue.set(state.tasks[task.status], currentIndex, task);
        if (currentIndex + 1 < state.tasks[task.status].length) {
          for (let i = currentIndex + 1; i < state.tasks[task.status].length; i++) {
            state.tasks[task.status][i].orden += 1; 
          }
        }
      }
    },

    pushTaskActivity(state, {taskActivity, task}) {
      const currentIndex = state.tasks[task.status].findIndex((t) => t.task_id === task.task_id);
      if (currentIndex > -1) {
        task = state.tasks[task.status][currentIndex];
        task.activities.unshift(taskActivity);
        Vue.set(state.tasks[task.status], currentIndex, task);
      }
    },

    deleteTask(state, {task, currentIndex}) {
      Vue.delete(state.tasks[task.status], currentIndex);
    },

    setUsers(state, users) {
      state.users = users;
    },

    setLoading(state, {status, loading}) {
      state.loading[status] = loading;
    },

  },

};
